export enum HAU_CHOICE {
  FAHRRADDIEBSTAHL = 'fahrraddiebstahl',
  GEBAEUDEART = 'gebaeudeart',
  BAUARTKLASSE = 'bauartklasse',
}

export enum HAU_META {
  FAHRRADDIEBSTAHL_REQUIRES_SUM = 'requiresSum',

  BAUARTKLASSE_IS_FERTIGHAUS = 'isFertighaus',
}
